import * as React from "react";

import { Spinner } from "@replo/design-system/components/spinner/Spinner";
import twMerge from "@replo/design-system/utils/twMerge";

export const Loader: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={twMerge(
        "flex h-full min-h-full content-center items-center justify-center",
        className,
      )}
    >
      <Spinner className="size-[50px]" variant="primary" />
    </div>
  );
};
